"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformResponseToDocument = exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash.isplainobject"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _constants = require("../constants");

var _fetch = _interopRequireDefault(require("./fetch"));

var _document = _interopRequireDefault(require("./document"));

var _JwtDecode = require("../util/JwtDecode");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _regeneratorRuntime() {
  "use strict";
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) {
            if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
          }

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var PUBLIC_URLS = ['/forgotten-password', '/set-password'];
var documentsCache = new Map();
/**
 * @param {Object} document
 * @param {bool} clone
 * @param {bool} addToCache
 *
 * @return {PeractoDocument}
 */

var transformResponseToDocument = function transformResponseToDocument(document) {
  var clone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var addToCache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (clone) {
    // deep clone documents
    document = JSON.parse(JSON.stringify(document));
  } // The main document is a JSON-LD document, convert it and store it in the cache


  if (document['@id']) {
    document = new _document["default"](document);
  } // Replace embedded objects by their IRIs, and store the object itself in the cache to reuse without issuing new HTTP requests.


  Object.keys(document).forEach(function (key) {
    // to-many
    if (Array.isArray(document[key]) && document[key].length && (0, _lodash["default"])(document[key][0]) && document[key][0]['@id']) {
      document[key] = document[key].map(function (obj) {
        if (addToCache) {
          documentsCache[obj['@id']] = transformResponseToDocument(obj, false, false);
        }

        return obj;
      });
    }
  });
  return document;
};

exports.transformResponseToDocument = transformResponseToDocument;

var _default = function _default(api) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var client = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _fetch["default"];
  var entrypoint = api.entrypoint;

  var convertRequest = function convertRequest(type, resource, params) {
    var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var entrypointUrl = new URL(entrypoint, window.location.href);
    var collectionUrl = new URL("".concat(entrypoint, "/").concat(resource), entrypointUrl);
    var itemUrl = new URL(params.id, entrypointUrl);

    switch (type) {
      case _constants.CREATE:
        return Promise.resolve({
          options: {
            body: JSON.stringify(params.data),
            method: 'POST',
            headers: headers
          },
          url: collectionUrl
        });

      case _constants.DELETE:
        return Promise.resolve({
          options: {
            method: 'DELETE',
            headers: headers
          },
          url: itemUrl
        });

      case _constants.GET_LIST:
        {
          var _params$pagination = params.pagination;
          _params$pagination = _params$pagination === void 0 ? {
            page: 1
          } : _params$pagination;
          var page = _params$pagination.page,
              perPage = _params$pagination.perPage,
              _params$sort = params.sort;
          _params$sort = _params$sort === void 0 ? {} : _params$sort;
          var field = _params$sort.field,
              order = _params$sort.order,
              name = params.name,
              label = params.label;
          if (order) collectionUrl.searchParams.set("order[".concat(field, "]"), order);
          if (page) collectionUrl.searchParams.set('page', page);
          if (perPage) collectionUrl.searchParams.set('itemsPerPage', perPage);
          if (name) collectionUrl.searchParams.set('name', name);
          if (label) collectionUrl.searchParams.set('label', label);

          if (params.filter) {
            Object.keys(params.filter).forEach(function (key) {
              var filterValue = params.filter[key];

              if ((0, _isArray["default"])(filterValue) && (filterValue === null || filterValue === void 0 ? void 0 : filterValue.length) > 0) {
                filterValue.forEach(function (value) {
                  collectionUrl.searchParams.append("".concat(key, "[]"), value);
                });
                return;
              }

              if (!(0, _lodash["default"])(filterValue)) {
                collectionUrl.searchParams.set(key, params.filter[key]);
                return;
              }

              Object.keys(filterValue).forEach(function (subKey) {
                collectionUrl.searchParams.set("".concat(key, "[").concat(subKey, "]"), filterValue[subKey]);
              });
            });
          }

          return Promise.resolve({
            options: {
              headers: headers
            },
            url: collectionUrl
          });
        }

      case _constants.GET_ONE:
      case _constants.GET_MANY:
        return Promise.resolve({
          options: {
            headers: headers
          },
          url: itemUrl
        });

      case _constants.UPDATE:
        return Promise.resolve({
          options: {
            body: JSON.stringify(params.data),
            method: 'PUT',
            headers: headers
          },
          url: itemUrl
        });

      default:
        throw new Error("Unsupported fetch action type ".concat(type));
    }
  };

  var convertResponse = function convertResponse(type, resource, response) {
    if (response.status === 204) {
      return Promise.resolve({
        data: {}
      });
    }

    switch (type) {
      case _constants.GET_LIST:
        // case GET_MANY_REFERENCE:
        return Promise.resolve(response.json['hydra:member'].map(transformResponseToDocument)).then(function (data) {
          return {
            data: data,
            total: response.json['hydra:totalItems']
          };
        });

      case _constants.DELETE:
        return Promise.resolve({
          data: {
            id: null
          }
        });

      case _constants.GET_MANY:
        return Promise.resolve(response.json['hydra:member'].map(transformResponseToDocument)).then(function (data) {
          return {
            data: data,
            response: response
          };
        });

      default:
        return Promise.resolve(transformResponseToDocument(response.json)).then(function (data) {
          return {
            data: data,
            response: response
          };
        });
    }
  };

  var revalidateUser = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(headers) {
      var claims, expiryDate, parsedDate, now, endpoint, json, _claims;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              claims = localStorage.getItem('claims');

              if (claims) {
                _context.next = 5;
                break;
              }

              clearLocalStorage();
              window.location.href = '/login';
              throw {
                status: 401,
                message: 'Claims could not be found, refreshing'
              };

            case 5:
              expiryDate = localStorage.getItem('expires_at');

              if (expiryDate) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return");

            case 8:
              // to convert php time
              parsedDate = Number(expiryDate) * 1000;
              now = new Date().getTime();

              if (!(parsedDate < now)) {
                _context.next = 32;
                break;
              }

              console.log('revalidating');
              endpoint = "".concat(process.env.REACT_APP_API || Cypress.env('api'), "/token/refresh");
              _context.prev = 13;
              _context.next = 16;
              return (0, _fetch["default"])(endpoint, {
                method: 'POST',
                body: JSON.stringify({
                  refresh_token: localStorage.getItem('refresh_token')
                }),
                headers: headers
              });

            case 16:
              _context.next = 32;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](13);

              if (!(_context.t0.response.status === 200)) {
                _context.next = 31;
                break;
              }

              _context.next = 23;
              return _context.t0.response.json();

            case 23:
              json = _context.sent;
              _claims = (0, _JwtDecode.decodeJwt)(json.token);
              localStorage.setItem('token', json.token);
              localStorage.setItem('claims', JSON.stringify(_claims));
              localStorage.setItem('expires_at', _claims.exp);
              localStorage.setItem('refresh_token', json.refresh_token);
              _context.next = 32;
              break;

            case 31:
              if (_context.t0.response.status === 401) {
                clearLocalStorage();
                window.location.href = '/login';
              }

            case 32:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[13, 18]]);
    }));

    return function revalidateUser(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var clearLocalStorage = function clearLocalStorage() {
    localStorage.removeItem('token');
    localStorage.removeItem('claims');
    localStorage.removeItem('expires_at');
    localStorage.removeItem('refresh_token');
  };

  var user = options.user,
      _options$onApiError = options.onApiError,
      onApiError = _options$onApiError === void 0 ? null : _options$onApiError;

  var fetchApi = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(type, resource, params, headers) {
      var _yield$convertRequest, url, _options, response, _e$response, err;

      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              if (PUBLIC_URLS.includes(window.location.pathname)) {
                _context2.next = 4;
                break;
              }

              _context2.next = 4;
              return revalidateUser(headers);

            case 4:
              _context2.next = 6;
              return convertRequest(type, resource, params, headers);

            case 6:
              _yield$convertRequest = _context2.sent;
              url = _yield$convertRequest.url;
              _options = _yield$convertRequest.options;
              _context2.next = 11;
              return client(url, _objectSpread(_objectSpread({}, _options), {}, {
                user: user
              }));

            case 11:
              response = _context2.sent;
              return _context2.abrupt("return", convertResponse(type, resource, response));

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](0);
              err = {
                api: api,
                error: _context2.t0,
                response: _context2.t0.response,
                status: _context2.t0.response ? _context2.t0.response.status : null
              };
              onApiError(err);

              if ((_context2.t0 === null || _context2.t0 === void 0 ? void 0 : (_e$response = _context2.t0.response) === null || _e$response === void 0 ? void 0 : _e$response.status) === 401 && !PUBLIC_URLS.includes(window.location.pathname)) {
                clearLocalStorage();
                window.location.href = '/login';
              }

              throw err;

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 15]]);
    }));

    return function fetchApi(_x2, _x3, _x4, _x5) {
      return _ref2.apply(this, arguments);
    };
  }();

  return fetchApi;
};

exports["default"] = _default;